module.exports = __webpack_public_path__ + "static/media/graph.2ed7fa70.png";